/**
 * Fault Tree View Type Definitions
 *
 * Defines the available view types for fault tree visualization and their metadata.
 */

/**
 * Enum of available fault tree view types
 */
export enum FaultTreeViewType {
    STANDARD = 'standard',
    BOWTIE = 'bowtie',
    // Future view types can be added here:
    // COMPACT = 'compact',
    // MINIMAL_CUT_SETS = 'minimalCutSets',
    // TABLE = 'table',
}

/**
 * Metadata describing a fault tree view type for UI display
 */
export interface FaultTreeViewMetadata {
    type: FaultTreeViewType;
    displayName: string;
    description: string;
    icon?: string;
}

/**
 * Registry of view type metadata for UI consumption
 */
export const FAULT_TREE_VIEW_METADATA: Record<FaultTreeViewType, FaultTreeViewMetadata> = {
    [FaultTreeViewType.STANDARD]: {
        type: FaultTreeViewType.STANDARD,
        displayName: 'Standard',
        description: 'Default hierarchical tree layout with full node details',
        icon: 'AccountTree'
    },
    [FaultTreeViewType.BOWTIE]: {
        type: FaultTreeViewType.BOWTIE,
        displayName: 'Bowtie',
        description: 'Bowtie diagram with Safety View on left, Fault Tree on right',
        icon: 'CallSplit'
    },
};
